module.exports = __webpack_public_path__ + "img/space-station-moon.32e621f8.svg";